import {
  ACTIVATION_RATE_TREND,
  CONVERSION_RATE_TREND,
  EXPANSION_RATE,
  SIGNUPS,
  TIME_TO_ACTIVATED,
  TIME_TO_ENGAGED,
  TRIALS_STARTED,
  TRIAL_TO_PAID_RATE,
} from "./exampleData";
import { MUTED } from "./chartTheme";
import MetricBarChart from "./MetricBarChart";

const pct = (v: number) => `${v}%`;
const count = (v: number) => `${v}`;
const days = (v: number) => `${v}d`;

export const ConversionRateChart = () => (
  <MetricBarChart
    caption="Signup-to-paid conversion climbs from 12% to 17%. Reported as a single blended figure it flatters bad months — the honest version is a cohort curve, but the trend still shows the direction."
    data={CONVERSION_RATE_TREND}
    seriesName="Conversion rate"
    format={pct}
    domain={[0, "dataMax + 8"]}
  />
);

export const ActivationRateChart = () => (
  <MetricBarChart
    caption="Activation rate rises from 40% to 50% — the share of new accounts that reach first value. It is the bridge between acquisition and retention: accounts that never activate almost always churn."
    data={ACTIVATION_RATE_TREND}
    seriesName="Activation rate"
    format={pct}
    domain={[0, 100]}
  />
);

export const TrialToPaidRateChart = () => (
  <MetricBarChart
    caption="Trial-to-paid conversion climbs from 24% to 31% — the share of trials that turn into paying customers within 30 days. It is the truest read on whether the trial delivers value fast enough."
    data={TRIAL_TO_PAID_RATE}
    seriesName="Trial-to-paid"
    format={pct}
    domain={[0, "dataMax + 10"]}
  />
);

export const ExpansionRateChart = () => (
  <MetricBarChart
    caption="Expansion rate rises from 8% to 13% — the share of paying accounts that upgraded, added seats or bought add-ons. A high rate means the product naturally pulls customers up-tier."
    data={EXPANSION_RATE}
    seriesName="Expansion rate"
    format={pct}
    domain={[0, "dataMax + 5"]}
  />
);

export const SignupsChart = () => (
  <MetricBarChart
    caption="Signups grow from 320 to 460 a month — the top of the funnel. On its own it is a vanity number; it only matters against how many activate and convert."
    data={SIGNUPS}
    seriesName="Signups"
    format={count}
    domain={[0, "dataMax + 80"]}
    yWidth={36}
  />
);

export const TrialsStartedChart = () => (
  <MetricBarChart
    caption="Trials started climb from 180 to 260 a month — intent to evaluate. Read it beside trial-to-paid conversion to see whether more trials are actually turning into revenue."
    data={TRIALS_STARTED}
    seriesName="Trials started"
    format={count}
    domain={[0, "dataMax + 60"]}
    yWidth={36}
  />
);

export const TimeToActivatedChart = () => (
  <MetricBarChart
    caption="Median time to activated falls from 4 days to 2 — how long a new signup takes to reach first value. Shorter is better: the faster the aha moment, the higher activation and retention."
    data={TIME_TO_ACTIVATED}
    seriesName="Time to activated"
    format={days}
    color={MUTED}
    domain={[0, "dataMax + 2"]}
  />
);

export const TimeToEngagedChart = () => (
  <MetricBarChart
    caption="Median time to engaged falls from 9 days to 6 — signup to the second value milestone. It marks the point where a customer moves from trying the product to relying on it."
    data={TIME_TO_ENGAGED}
    seriesName="Time to engaged"
    format={days}
    color={MUTED}
    domain={[0, "dataMax + 3"]}
  />
);
